import React from 'react';

import StatusSummaryTableRow from './StatusSummaryTableRow';
import './StatusSummaryTable.scss';

class StatusSummaryTable extends React.Component {


  render() {
    const suspensionStatus = this.props.parker.fields.suspension_status.value;
    const accessStatus = this.props.parker.fields.access_system_status.value;
    const terminationStatus = this.props.parker.fields.termination_status.value;

    return (
      <table className="parkchirp--status-summary-table">
        <tbody>
          <StatusSummaryTableRow rowLabel={"Suspension Status"} rowValue={suspensionStatus} />
          <StatusSummaryTableRow rowLabel={"Access Status"} rowValue={accessStatus} />
          <StatusSummaryTableRow rowLabel={"Termination Status"} rowValue={terminationStatus} />
        </tbody>
      </table>
    );
  }
}

export default StatusSummaryTable;
